import { Module } from 'wrapper6';
import $ from 'jquery';
import selectize from 'selectize';

export default class SelectChoices extends Module {
	ready() {
		$('#cities').selectize({
			create: false,
			sortField: 'text',
			onChange: value => {
				this.handleOptionSelect(value);
			}
		});

		$('#book-coach-select').selectize({
			create: false,
			sortField: 'text',
			onChange: value => {
				this.handleCoachUpdate(value);
			}
		});

		$('#book-coach-btn').on('click', function(e) {
			if ($(this).hasClass('disabled')) {
				e.preventDefault();
			}
		});

		$('.selectize-multiple').selectize({
			plugins: ["remove_button"],
			delimiter: ',',
            persist: false,
            create: false

        });

		this.placeholderHandler();
	}

	handleOptionSelect(value) {
		if (value.indexOf('http') > -1) {
			window.location.href = value;
		}
	}

	handleCoachUpdate(value) {
		$('#book-coach-btn').attr('href', value);
		if (value == '') {
			$('#book-coach-btn').addClass('disabled');
		} else {
			$('#book-coach-btn').removeClass('disabled');
		}
	}

	placeholderHandler() {

		const CITIES_PLACEHOLDER = document.querySelector('[data-mobile-placeholder]');
		const CITIES_INPUT = document.getElementById('cities-selectized');

		if (CITIES_PLACEHOLDER && CITIES_INPUT) {

			const OLD_TEXT = CITIES_INPUT.placeholder;
			const NEW_TEXT = CITIES_PLACEHOLDER.getAttribute('data-mobile-placeholder');

			// switch placeholder
			this.switchPlaceholder(CITIES_INPUT, OLD_TEXT, NEW_TEXT);
			window.addEventListener('resize', () => this.switchPlaceholder(CITIES_INPUT, OLD_TEXT, NEW_TEXT));
		}
	}

	switchPlaceholder(input, old_text, new_text) {
		if (old_text != '' && new_text != '') {
			input.placeholder = this.getScreenWidth() <= 580 ? new_text : old_text;
		}
	}

	getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_select-choices.js